import script from "./PIIFormView.vue?vue&type=script&setup=true&lang=js"
export * from "./PIIFormView.vue?vue&type=script&setup=true&lang=js"

import "./PIIFormView.vue?vue&type=style&index=0&id=45b7c663&lang=css"

const __exports__ = script;

export default __exports__